<template>
  <Modal v-model="paymentFeatureAlert">
    <div class="p-8">
      <div class="flex flex-col justify-center items-center">
        <img
          class="object-cover"
          :src="require(`@/assets/svg/work-in-progress.svg`)"
          alt="..."
        />
        <p class="text-lg">Coming Soon!</p>
        <p class="text-sm text-gray-light">
          We will notify you once this feature is ready
        </p>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal } from "@/components/t-components";

export default {
  name: "PaymentAlertModal",
  components: {
    Modal,
  },
  props: {
    paymentFeatureAlert: {
      type: Boolean,
    },
  },
};
</script>